"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

var INIT = "[Redux call] Init";
var CALL = "[Redux call] Call";
var CLEAR = "[Redux call] Clear";
/**
 * @param {string|number|Symbol} instanceId
 * @returns {{type: string, payload: {instanceId: string|number|Symbol}}}
 */

var init = function init(instanceId) {
  return {
    type: INIT,
    payload: {
      instanceId: instanceId
    }
  };
};
/**
 * @param {string|number|Symbol} instanceId
 * @param {object} command
 * @param {string} command.method
 * @param {array} [command.args = []]
 * @param {function} [command.callback = ()=>{}]
 * @returns {{type: string, payload: {instanceId: *, command: *}}}
 */


var call = function call(instanceId, command) {
  return {
    type: CALL,
    payload: {
      instanceId: instanceId,
      command: command
    }
  };
};
/**
 * @param {string|number|Symbol} instanceId
 * @returns {{type: string, payload: {instanceId: *}}}
 */


var clear = function clear(instanceId) {
  return {
    type: CLEAR,
    payload: {
      instanceId: instanceId
    }
  };
};
/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */


var callReducer = function callReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var newState = void 0,
      instanceId = void 0;

  switch (action.type) {
    case INIT:
      newState = Object.assign({}, state);
      instanceId = action.payload.instanceId;
      newState[instanceId] = [];
      return newState;

    case CALL:
      instanceId = action.payload.instanceId;

      if (!state[instanceId]) {
        return state;
      }

      newState = Object.assign({}, state);
      newState[instanceId].push(action.payload.command);
      return newState;

    case CLEAR:
      newState = Object.assign({}, state);
      instanceId = action.payload.instanceId;
      newState[instanceId] = [];
      return newState;

    default:
      return state;
  }
};
/**
 * Enables calling of react component methods by commands from store
 *
 * @param {object} instance
 * @param {string|number|Symbol}instanceId
 * @param {string} commandsAccessor - property name in this.props that represents commands object from callReducer
 */


var enableCalls = function enableCalls(instance, instanceId, commandsAccessor) {
  var dispatch = instance.props.dispatch;
  var oldComponentWillMount = instance.componentWillMount ? instance.componentWillMount : function () {};
  var oldComponentWillReceiveProps = instance.componentWillReceiveProps ? instance.componentWillReceiveProps : function () {};

  instance.componentWillMount = function () {
    dispatch(init(instanceId));
    oldComponentWillMount.call(instance);
  };

  instance.componentWillReceiveProps = function (nextProps) {
    if (!nextProps[commandsAccessor]) {
      return oldComponentWillReceiveProps.call(instance, nextProps);
    }

    var commands = nextProps[commandsAccessor][instanceId];

    if (commands && commands.length > 0) {
      dispatch(clear(instanceId));
      commands.forEach(function (_ref) {
        var method = _ref.method,
            _ref$args = _ref.args,
            args = _ref$args === undefined ? [] : _ref$args,
            _ref$callback = _ref.callback,
            callback = _ref$callback === undefined ? function () {} : _ref$callback;

        if (instance[method]) {
          var executionResult = instance[method].apply(instance, _toConsumableArray(args));
          callback(executionResult);
        }
      });
    }

    oldComponentWillReceiveProps.call(instance, nextProps);
  };
};

exports.enableCalls = enableCalls;
exports.callReducer = callReducer;
exports.clear = clear;
exports.call = call;
exports.init = init;